const ecoSystem = [
  { value: 1, label: 'Terrestrial' },
  { value: 2, label: 'Marine' },
  { value: 3, label: 'Freshwater' },
  { value: 4, label: 'Subterranean' }
]

export default ecoSystem
